import React from 'react';

function CreatePlaylistButton({ onClick }) {
  return (
    <button
      type="button"
      className="btn-create-playlist"
      onClick={onClick}
      aria-label="Create custom playlist"
    >
      <i className="material-icons">add</i>
    </button>
  );
}

export default CreatePlaylistButton;
